import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SettingsDropdown, ModalWrapper } from 'src/components'
import { UserLanguageForm } from './user-language-form.component'
import { GlobalNetIcon } from 'src/assets/icons'

import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'

const UserLanguage = () => {
  const [t] = useTranslation(ETranslationNs.UserProfile)
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <SettingsDropdown
        text={t('user-language-title.v')}
        icon={<GlobalNetIcon />}
        onButtonClick={handleOpen}
      />
      <ModalWrapper className={classes.formWrapper} onClose={handleClose} open={open}>
        <UserLanguageForm handleClose={handleClose} />
      </ModalWrapper>
    </>
  )
}

export { UserLanguage }
